




























































// vendor
import { defineComponent, computed } from "@vue/composition-api";
// project
import { useTags } from "@/hooks/useTags";
import { Dictionary } from "@/utils/types";
import { getAssetTypes } from "@/psychlab/meta";
import { getInverseColor } from "@/utils/color";
import { useRecentAssets } from "./useRecentAssets";
import { useTranslate } from "@lang";
import { Date } from "@ui";

const config = {
	colors:{
		"Form":"#9471fe",
		"Select":"white",
		"Scene":"#0a9931",
		"CognitiveTest":"#00bdd6",
		"Gallery":"#f07705",
		"Start":"white",
		"empty":"black",
		"Graph":"#117a8b"
	} as Dictionary<string>,
	icons:{
		"Form":"mdi.file-document-edit text-dark",
		"Select":"mdi.arrow-decision mdi-rotate-180 text-dark",
		"Scene":"mdi.rotate-3d text-dark",
		"CognitiveTest":"mdi.head-cog mdi-flip-h text-dark",
		"Gallery":"mdi.image-multiple text-dark",
		"Start":"mdi.flash text-dark",
	} as Dictionary<string>
};

const assetTypes:any = {};
getAssetTypes().forEach(at => assetTypes[at.name] = at);

export default defineComponent({
	components:{
		Date
	},
	setup(props){

		const { translate } = useTranslate();

		const tagHooks = useTags();

		const days = computed(() => 7);

		
		const activityMessage = computed(() => {
			const ms = translate("message.noActivity");
			return ms.replace("$n", days.value.toString());
		});

		const { assets } = useRecentAssets(days);

		const getTypeIcon = (t:string) => {
			return assetTypes[t] ? assetTypes[t].icon : "mdi.circle-outline";
		};

		const getAssetRoute = (id:string) => {
			return {
				name:"view-asset",
				params:{
					assetId:id
				}
			}
		};

		const getLabelColor = (bgColor:string) => getInverseColor(bgColor);
		
		const getAssetTags = (id:string) => tagHooks.getItemTags(id);
		
		const getTypeColor = (t:string) => config.colors[t] || "transparent";
		

		return {
			assets,
			activityMessage,
			translate,
			getTypeIcon,
			getAssetRoute,
			getAssetTags,
			getLabelColor,
			getTypeColor,
		};
	}
});

